import React from 'react'

import { useActions, useMutations } from 'src/hooks'
import { getTotal } from 'src/helpers'
import Editor from 'src/editor/containers/Editor/Editor'

type Props = {
  cardId: string
}

const Card: React.FC<Props> = props => {
  const { cardId } = props

  const mutations = useMutations()
  const actions = useActions()

  const createOrder = async () => {
    const { createOrder } = await mutations.createOrder({
      order: { lines: [{ card: cardId }] },
    })
    return createOrder.order
  }

  const handleSaveAndSend = async () => {
    const order = await createOrder()
    actions.openOrder(order.id)
  }

  const handleSaveAndClose = async () => {
    actions.openCatalog()
  }

  const handleOnClose = () => {
    actions.openCatalog()
  }

  return (
    <Editor
      cardId={cardId}
      onAfterSave={handleSaveAndSend}
      onClose={handleOnClose}
      saveButtonLabel="Save &amp; Send"
      secondaryAction={{
        label: 'Save & Close',
        onClick: handleSaveAndClose,
      }}
      context={{
        headerText: 'Editing custom card',
        footerLabel: card => <>Total: {getTotal(card.cost)}</>,
      }}
    />
  )
}

export default Card
